import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TrackingEvents from '../components/TrackingEvents';

import Card, { CardHeader, CardSection } from './Card';


function hexToRgb(hex) {
  const DEFAULT_COLOR = { r: 0, g: 0, b: 0 };

  if( !hex || hex.length !== 7 || hex[0] !== "#" ) {
    console.warn(`Invalid hex color in TrackingCard: '${hex}'`);
    return DEFAULT_COLOR
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result ? (
    {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
  ) : (
    DEFAULT_COLOR
  );
}

const useStyles = makeStyles( theme => ({
  scrollableSection: {
    overflow: 'auto',
    height: 'calc(100% - 42px)',
  },
  eventRow: () => {
    const recentDotColor = (theme.custom3 && theme.custom3.color) || (theme.main && theme.main.color);
    const rgbRecentDotColor = hexToRgb(recentDotColor);

    return {
      paddingLeft: '38px',
      position: 'relative',
      '&::before': {
        content: '""',
        width: '8px',
        height: '8px',
        borderRadius: '100%',
        backgroundColor: '#dedede',
        position: 'absolute',
        left: '20px',
        top: '15px',
      },
      '& + &': {
        color: '#929292'
      },
      '&:first-child::before': {
        backgroundColor: recentDotColor,
        top: '38px',
        boxShadow: `0px 0px 0px 2px rgba(${rgbRecentDotColor.r},${rgbRecentDotColor.g},${rgbRecentDotColor.b}, 0.30)`
      }
    };
  },
  mostRecentLabel: {
    fontSize: '10px',
    fontWeight: '700',
    lineHeight: '12px',
    letterSpacing: '0',
    textTransform: 'uppercase',
    marginBottom: '12px',
    marginLeft: '-18px'
  },
  trackingEvent: {
    '& .timestamp': {
      fontSize: '10px',
      fontWeight: '700',
      lineHeight: '12px',
      display: 'block',
      textTransform: 'uppercase',
      marginBottom: '2px'
    },
    '& .description, & .location': {
      fontSize: '12px',
      fontWeight: '300',
      lineHeight: '14px',
      letterSpacing: '0'
    },
    '& .location': {
      marginLeft: '3px'
    }
  },
  noTrackingEventsMsg: {
    padding: '15px 20px',
    fontStyle: 'italic',
    color: '#929292'
  }
}));


export default function TrackingCard({ className }) {
  const classes = useStyles();

  return (
    <Card className={className} aria-labelledby="tracking-header">
      <CardHeader id="tracking-header">
        Shipment Progress
      </CardHeader>
      <div className={classes.scrollableSection} role="list">
        <TrackingEvents
          timestampFormat='MMMM D - h:mm A'
          eventClassName={classes.trackingEvent}
          emptyMsgClassName={classes.noTrackingEventsMsg}
          eachEvent={ ({ content,key,index }) => (
            <CardSection className={classes.eventRow} key={key}>
              { (index === 0) &&
                <div className={classes.mostRecentLabel}>Most Recent</div>
              }
              {content}
            </CardSection>
          )}
        />
      </div>
    </Card>
  );
}